import React, {useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {DropzoneAreaBase} from "material-ui-dropzone";
import makeStyles from "@material-ui/core/styles/makeStyles.js";
import {Button} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {getActiveEnvironmentState, loadingActiveEnvironmentState} from "../../redux/reducers/master-of-acts-reducer.js";
import {useParams} from "react-router-dom";
import { 
    downloadExcelTemplate, 
    getExcelTemplate, 
    selectExcelTemplate, 
    uploadExcelTemplate } from '../../redux/reducers/excel-template-edit-reducer.js';

const useStyles = makeStyles((theme) => (
    {
        root: {
            padding: theme.spacing(2),
            height: '100%'
        },
        dropzoneGrid: {
            flex: 1
        },
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))

const ExcelTemplateUploadContainer = () => {
    const {projectID} = useParams()

    const [files, setFiles] = useState([])

    const classes = useStyles()

    const dispatch = useDispatch()

    const environmentState = useSelector(getActiveEnvironmentState)
    const excelTemplate = useSelector(selectExcelTemplate)

    const handleDownloadFile = async () => {
        dispatch(downloadExcelTemplate(excelTemplate?.id))
    }

    const handleAddFile = async (newFiles) => {
        setFiles(newFiles)
    }

    const handleDeleteFile = async () => {
        setFiles([])
    }

    const handleSubmitButtonClick = async () => {
        await dispatch(uploadExcelTemplate(excelTemplate.id, projectID, files[0]))
        await dispatch(loadingActiveEnvironmentState(projectID))
    }

    useEffect(() => {
        if (projectID) {
            dispatch(loadingActiveEnvironmentState(projectID))
        }
    }, [dispatch])

    // useEffect(() => {
    //     if (environmentState) {
    //         dispatch(getWordTemplate(environmentState.word_template))
    //     }
    // }, [environmentState])

    useEffect(() => {
        if (environmentState) {
            dispatch(getExcelTemplate(environmentState.excel_template))
        }
    }, [environmentState])

    useEffect(() => {
        if (excelTemplate.file){
            setFiles([excelTemplate])
        }
    }, [excelTemplate])

    return (
        <Grid container direction={'column'} className={classes.root}>
            <Grid item alignItems={'center'} className={classes.dropzoneGrid}>
                <DropzoneAreaBase
                    // acceptedFiles={[ ПОТОМ ПЕРЕДЕЛАТЬ ПОД РУКОВОДСТВОМ МАСТЕРА
                    //     'application/vnd.openxmlformats-officedocument.excelprocessingml.document'
                    // ]}
                    fileObjects={files}
                    maxFileSize={10000000}
                    filesLimit={1}
                    onAdd={handleAddFile}
                    onDelete={handleDeleteFile}
                    dropzoneText={'Нажмите на выделенную область или перетащите файлы для загрузки'}
                    getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
                    getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
                    getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
                    getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    previewGridProps={{container: {spacing: 1, direction: 'row'}}}
                    previewChipProps={
                        {
                            classes: {
                                root: classes.previewChip,
                            },
                            onClick: handleDownloadFile,
                        }}
                    previewText="Загруженные файлы"
                />
            </Grid>
            <Grid item container justifyContent={'flex-end'}>
                <Button variant={'contained'} onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </Grid>
        </Grid>
    );
};

export default ExcelTemplateUploadContainer;